import { create } from '@dojo/framework/core/vdom';

import injector from '@dojo/framework/core/middleware/injector';
import Router from '@dojo/framework/routing/Router';
import { Params } from '@dojo/framework/routing/interfaces';

const factory = create({ injector });

export default factory(function router({ middleware: { injector } }) {
	const router = injector.get<Router>('router');
	if (!router) {
		throw new Error('router not found');
	}
	return {
		link(
			to: string,
			{
				params = {},
				query = {},
				hash
			}: { params?: Params; query?: Params; hash?: string } = {}
		) {
			let href = router.link(to, params);
			if (href) {
				href = Object.keys(query).reduce((href, key) => {
					const sep = href.indexOf('?') === -1 ? '?' : '&';
					return `${href}${sep}${key}=${query[key]}`;
				}, href);
				if (hash) {
					href = `${href}#${hash}`;
				}
			}
			return href;
		}
	};
});
